import { MoreVert } from '@mui/icons-material';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

const MoreOptions = ({
    menuItems,
}: {
    menuItems: { label: string; onClick: () => void; disabled?: boolean; hidden?: boolean }[];
}) => {
    const [rowActionsAnchorEl, setRowActionsAnchorEl] = useState<null | HTMLElement>(null);
    const visibleMenuItems = menuItems.filter((item) => !item.hidden);
    if (visibleMenuItems.length === 0) return null;
    return (
        <Box>
            <IconButton
                size='small'
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation();
                    setRowActionsAnchorEl(e.currentTarget);
                }}
            >
                <MoreVert />
            </IconButton>
            <Menu
                open={!!rowActionsAnchorEl}
                onClose={(e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation();
                    setRowActionsAnchorEl(null);
                }}
                anchorEl={rowActionsAnchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.stopPropagation();
                }}
            >
                {visibleMenuItems.map((item) => (
                    <MenuItem
                        key={item.label}
                        onClick={(e: React.MouseEvent<HTMLElement>) => {
                            e.stopPropagation();
                            item.onClick(e);
                            setRowActionsAnchorEl(null);
                        }}
                        disabled={item.disabled}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default MoreOptions;
